'use client'
import { formatNumberToNumericalAbreviation } from 'utils/number'

import { useProductDataQuery } from '@web/hooks/use-product-data'

export function ViewsValue({ defaultTotal }: { defaultTotal: number }) {
  const { data } = useProductDataQuery()
  const viewsTotal = data?.views_count || 0

  return (
    <span data-testid="stat-views-value">
      {formatNumberToNumericalAbreviation(viewsTotal || defaultTotal)}
    </span>
  )
}
